/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_TitleInputs */

const en_gc_resources_faq_title = /** @type {(inputs: Gc_Resources_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before your first workbook.`)
};

const zh_gc_resources_faq_title = /** @type {(inputs: Gc_Resources_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开首个工作簿之前。`)
};

/**
* | output |
* | --- |
* | "Before your first workbook." |
*
* @param {Gc_Resources_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_title = /** @type {((inputs?: Gc_Resources_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_title(inputs)
	return zh_gc_resources_faq_title(inputs)
});
export { gc_resources_faq_title as "gc.resources.faq.title" }